export function setAddressAndLocation(unsavedChanges, geolocation){
  if(unsavedChanges.attributes && unsavedChanges.attributes.field_address){
    const getComponent = (type) => geolocation[0].address_components.filter((comp) => comp.types.includes(type))[0];
    const addressLine1 = getComponent('street_number') ? `${getComponent('street_number').long_name} ${getComponent('route').short_name}` : null;
    const locality = getComponent('locality') ? getComponent('locality').long_name : null;
    const postalCode = getComponent('postal_code') ? getComponent('postal_code').long_name : null;
    unsavedChanges.attributes.field_address.address_line1 = addressLine1;
    unsavedChanges.attributes.field_address.locality = locality;
    unsavedChanges.attributes.field_address.administrative_area = "OR";
    unsavedChanges.attributes.field_address.country_code = "US";
    unsavedChanges.attributes.field_address.postal_code = postalCode;
    unsavedChanges.attributes.field_location = geolocation[0].geometry.location;
  }
}
